import React from "react";

import config from "config/config";

// ======================= Constants =======================
const DASHBOARD_LOGO = (Array.isArray(config?.LOGO_REPORT) ? config.LOGO_REPORT : []).find(
  (i: any) => i?.type === 1,
);
const DASHBOARD_LOGO_SRC = DASHBOARD_LOGO?.src ?? "images/IHimage.png";
const HOSPITAL_NAME = "โรงพยาบาล มอร์เฮลท์ แคร์";

// ======================= Header =======================
type DashboardHeaderProps = {
  title: string;
  divisionName?: string;
  date: string;
  time: string;
};

export const DashboardHeader = (props: DashboardHeaderProps) => (
  <div style={{ position: "relative", padding: "8px 10px" }}>
    <div style={{ display: "flex", alignItems: "center", margin: "0 10px" }}>
      <div style={{ margin: "0 10px" }}>
        <img src={DASHBOARD_LOGO_SRC} style={{ height: "60px" }} alt="logo" />
      </div>
      <div style={{ width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginLeft: "5px" }}>
          <div style={{ fontWeight: "bold", fontSize: "18px" }}>{HOSPITAL_NAME}</div>
          <div style={{ fontWeight: "bold", fontSize: "18px" }}>{props.date}</div>
        </div>
        <div style={{ border: "1px solid rgb(29, 189, 212)" }} />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginLeft: "5px",
            marginTop: "5px",
          }}
        >
          <div style={{ fontWeight: "bold", fontSize: "17px" }}>
            {props.divisionName || "ห้องแลป"}
          </div>
          <div style={{ fontWeight: "bold", fontSize: "17px" }}>{props.time}</div>
        </div>
      </div>
    </div>

    {/* Title badge (absolute center) */}
    <div style={{ justifyContent: "center", display: "flex" }}>
      <div
        style={{
          backgroundColor: "rgb(29, 189, 212)",
          borderRadius: "10px",
          margin: "10px",
          padding: "10px",
          width: "20%",
          position: "absolute",
          top: "6px",
          textAlign: "center",
        }}
      >
        <label
          style={{
            fontWeight: "bold",
            fontSize: "24px",
            color: "white",
            display: "block",
          }}
        >
          {props.title}
        </label>
      </div>
    </div>
  </div>
);

// ======================= Footer =======================
type DashboardFooterProps = {
  passedCount: number;
};

export const DashboardFooter = (props: DashboardFooterProps) => (
  <div style={{ margin: "0 10px 10px 10px", backgroundColor: "#FFB4B4", flexShrink: 0 }}>
    <div style={{ display: "flex", padding: "10px", alignItems: "center" }}>
      <div style={{ fontWeight: "bold", fontSize: "20px", marginRight: "10px" }}>
        เรียกผ่านไปแล้ว:
      </div>
      <div style={{ fontWeight: "bold", fontSize: "20px" }}>{props.passedCount}</div>
      <div style={{ flex: 1 }} />
      <div style={{ fontWeight: "bold", fontSize: "20px", marginRight: "5px" }}>
        | กรุณาติดต่อเคาเตอร์พยาบาล
      </div>
    </div>
  </div>
);
